module.exports = __webpack_public_path__ + "img/demo.fd10a768.png";